module.exports = __webpack_public_path__ + "static/media/education.ab579d86.jpg";